import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { Select } from "@ngxs/store";
import { Observable } from "rxjs";
import { AppState } from "src/app/app.state";
import { translate, translateAndFormat } from "src/app/i18next";
import { InspectionTypeSummary } from "src/app/models/inspection-type-summary.model";
import { TripStartOrEnd } from "src/app/models/mir-rule.model";
import { LanguageDictionaryService } from "src/app/services/language-dictionary/language-dictionary.service";
import { RulesService } from "src/app/services/rules/rules.service";

@Component({
	selector: "app-trip-start-end",
	templateUrl: "./trip-start-end.component.html",
	styleUrls: ["./trip-start-end.component.scss"],
})
export class TripStartEndComponent implements OnInit, OnChanges {
	constructor(private rulesService: RulesService, private langService: LanguageDictionaryService) {}

	@Input() tripStartOrEnd: TripStartOrEnd = null;
	@Input() tripZones = translateAndFormat("none", "capitalize");
	@Select(AppState.selectInspectionTypes)
	inspectionTypes: Observable<InspectionTypeSummary[]>;

	private latestInspectionTypes: InspectionTypeSummary[] = [];

	tripInspectionTypes: string = null;

	zonesTripTypes = ["exit_zone", "enter_zone"];

	ngOnInit(): void {
		this.inspectionTypes?.subscribe(types => {
			this.latestInspectionTypes = types ?? [];
			if (this.tripStartOrEnd) {
				this.tripInspectionTypes = this.getInspectionNames();
			}
		});
	}

	translateIntsToDays(ints: number[]): string {
		return ints
			.map(int => {
				return this.rulesService.intToDay(int) || "Unknown Day";
			})
			.join(", ")
			.trim();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes?.tripStartOrEnd?.currentValue) {
			this.tripStartOrEnd = changes.tripStartOrEnd.currentValue;
			this.tripInspectionTypes = this.getInspectionNames();
		}
	}

	formatStringForDisplay(term: string): string {
		return translateAndFormat(term.split("_").join(" "), "capitalize");
	}

	getInspectionNames(): string {
		return this.tripStartOrEnd.inspectionTypes
			.map(insp => {
				const match = this.latestInspectionTypes.find(t => t.inspectionTypeId === insp.inspectionType);
				return (match && this.langService.getTranslation(match.langId)) || translate("unknown inspection type");
			})
			.join(", ")
			.trim();
	}
}
